/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { Row, Col } from 'react-bootstrap';
import {
    Panel, Button, Progress, Breadcrumb,
} from 'appkit-react';

const ReconStatus = ({
    projectDetails, progress, indicators, status, userNames,
    onViewResult, breadCrumbItems, navigateToConfigPage, errorReason,
    maxProgressPercent,
}) => {
    const customProgressStyle = { minWidth: '500px' };
    return (
        <div className="true-comply-datarecon-status-page-layout">
            <div className="true-comply-datarecon-status-page">
                <Breadcrumb items={breadCrumbItems} />
                <div className="a-h3">
                    <span className="appkiticon icon-left-chevron-outline left-arrow-icon" onClick={() => navigateToConfigPage()} role="presentation" />
                    Data Reconciliation Status
                </div>
                <div className="panel-layout">
                    <Panel
                        title="PROJECT DETAILS"
                        className="a-increase-child-color-level-by-1"
                    >
                        <Row>
                            <Col md={6}>
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        ID
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {projectDetails && projectDetails.projectId}
                                    </Col>
                                </Row>
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        Project name
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {projectDetails && projectDetails.projectName}
                                    </Col>
                                </Row>
                                <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                    <Col md={3} className="a-h6">
                                        Description
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {projectDetails && projectDetails.projectDesc}
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6}>
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        Project owner
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {projectDetails && projectDetails.ownerName}
                                    </Col>
                                </Row>
                                <Row className="row-margin">
                                    <Col md={3} className="a-h6">
                                        Status
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {projectDetails && projectDetails.status}
                                    </Col>
                                </Row>
                                <Row className="row-margin" style={{ paddingBottom: '1.5rem' }}>
                                    <Col md={3} className="a-h6">
                                        Project users
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {userNames}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Panel>
                </div>
                <div className="panel-layout">
                    <Panel
                        title="DATA RECONCILIATION STATUS"
                        className="a-increase-child-color-level-by-1"
                    >
                        <Row>
                            <Col md={9}>
                                <Row className="true-comply-datarecon-status-row-margin">
                                    <Col md={3} className="a-h6">
                                        Progress
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={9}>
                                        <Progress style={customProgressStyle} percent={progress} indicators={indicators} />
                                    </Col>
                                </Row>
                                <Row className="true-comply-datarecon-status-row-margin">
                                    <Col md={3} className="a-h6">
                                        Status
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {status}
                                    </Col>
                                </Row>
                                <Row className="true-comply-datarecon-status-row-margin" style={{ paddingBottom: '1.5rem' }}>
                                    <Col md={3} className="a-h6">
                                        Fail Reason
                                        <span className="label">:</span>
                                    </Col>
                                    <Col md={8}>
                                        {errorReason}
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={3}>
                                <Row className="true-comply-datarecon-status-row-margin">
                                    <Col md={6} className="a-h6">
                                        <Button
                                            size="sm"
                                            kind="secondary"
                                            disabled={progress !== maxProgressPercent || status !== 'SUCCESS'}
                                            onClick={onViewResult}
                                        >
                                            VIEW RESULT
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Panel>
                </div>
            </div>
        </div>
    );
};

export default ReconStatus;
